'use client';

import { useGardenPlannerStore } from '@shared/store/useGardenPlannerStore';
import { useSetAllCellsAvailability } from '@api/gardens';
import { useGarden } from '@modules/garden-planner/context/garden_planner_context';
import { createHandleSetAllCellsAvailability } from '@modules/garden-planner/sidebar/availability_tool/business_logic';
import type { GardenPlannerViews } from '@modules/garden-planner/garden_planner_views';

interface AvailabilityToolContainerProps {
  views: GardenPlannerViews;
}

export function AvailabilityToolContainer({ views }: AvailabilityToolContainerProps) {
  const { AvailabilityToolView } = views;
  const isAvailabilityMode = useGardenPlannerStore((state) => state.isAvailabilityMode);
  const setActiveMode = useGardenPlannerStore((state) => state.setActiveMode);
  const garden = useGarden();
  const setAllCellsAvailability = useSetAllCellsAvailability();

  const handleSetAllCellsAvailability = createHandleSetAllCellsAvailability(
    garden,
    setAllCellsAvailability
  );
  const handleToggle = () => setActiveMode(isAvailabilityMode ? null : 'availability');

  return (
    <AvailabilityToolView
      isActive={isAvailabilityMode}
      onToggle={handleToggle}
      onSetAllCellsAvailability={handleSetAllCellsAvailability}
    />
  );
}
